module.exports = __webpack_public_path__ + "img/logo-name.cab4c471.png";